// extracted by mini-css-extract-plugin
export var adjacentSlide = "_r1-9";
export var arrowButtonContainer = "_r1-5";
export var arrowButtonIcon = "_r1-6";
export var carouselArrowButton = "_r1-2";
export var carouselElementContainer = "_r1-1";
export var currentSlide = "_r1-8";
export var left = "_r1-3";
export var otherSlide = "_r1-a";
export var productCarouselContainer = "_r1-0";
export var right = "_r1-4";
export var sliderOverflow = "_r1-7";